import { createFileRoute, redirect } from "@tanstack/react-router";

// /settings has no page of its own — the Account and Workspace sections all
// live under real child routes. Land non-admins on Profile; admins still get
// Profile first because it's Account > Workspace in the nav order.
export const Route = createFileRoute("/_app/settings/")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/profile" });
	},
});
